import React, { Component } from 'react';
import { Loader } from '../../utils/common';
import { Row, Col,  Modal, Button, ModalHeader, ModalBody, ModalFooter,  FormGroup, Label, Input, Form , Alert } from "reactstrap";
import { AppSwitch } from '@coreui/react'
import SimpleReactValidator from 'simple-react-validator';
import Autocomplete from 'react-autocomplete';
import * as _ from 'underscore';



class AddQuest extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      contentId : "",
      contentTitle : "",
      additionalPoints: 1,
      occurrence: 1,
      status : true,
      tagline : "",
      typedContent: '',
      requestProcess : false,
      systemLanguages: props.systemLanguages,
    }
  }

  componentDidMount() {
    //this.setContent();
  }


  setContent() {
    if (this.props.contentData && this.props.contentData.length) {
      let contentObj = _.first(this.props.contentData);
      this.setState({
        contentId : contentObj['_id'],
        contentTitle : contentObj['title'],
        typedContent : contentObj['title'],
        additionalPoints: 1,
        occurrence: 1,
        status : true,
        tagline : "",
        requestProcess : false
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    //let self = this;
    Loader(nextProps.requestProcess);
    this.setState({requestProcess : nextProps.requestProcess})
  }




  handleChange(event) {
    let target = event.currentTarget;
    let name = target.name;
    let value;

    if (target.type === 'checkbox') {
      value = target.checked;
    }else {
      value = target.value;
    }


    if (target.name === 'additionalPoints' && value > 1000 ) {
      return false;
    }else {
      value = target.value;
    }


    if (target.name === 'occurrence' && value > 100 ) {
      return false;
    }else {
      value = target.value;
    }


    if (target.name === 'status' && target.type === 'checkbox' ) {
      value = target.checked;
    }else {
      value = target.value;
    }
    this.setState({[name]: value});
  }

  handleSubmit(e) {
    if( this.validator.allValid()){
      let languageData = [];
      _.each(this.state.systemLanguages, function(value, index){
        languageData.push(value['dailyQuestLang']);
      })


      let params = {
        contentId : this.state.contentId,
        additionalPoints: parseInt(this.state.additionalPoints),
        occurrence: parseInt(this.state.occurrence),
        status : this.state.status,
        dailyQuestLang : languageData

      }


      this.setState({requestProcess : true})
      this.props.addQuest(e, params)
      this.clearStateData()
    }else{
      this.validator.showMessages();
      this.forceUpdate();
    }
    e.preventDefault();
  }

  clearStateData() {
    this.setState({
      contentId : "",
      contentTitle : "",
      additionalPoints: 1,
      occurrence: 1,
      status : true,
      tagline : "",
      typedContent: '',
      requestProcess : true
    })
  }


  onSelect(item){
    this.setState({contentId: item._id, contentTitle: item.title, typedContent: item.title})
  }


  LanguagesToRender() {
    let self = this;
    return self.state.systemLanguages.map(function(obj, index){
      return (
        <div key={obj.slug}>
          <Row>
            <Col xs="12">
                <FormGroup>
                  <Label htmlFor="title">{obj.title} Tagline</Label>

                  <Input type="text" id={obj.title} placeholder={obj.title + ' Tagline'} name="description" value={(self.state.systemLanguages[index].dailyQuestLang && self.state.systemLanguages[index].dailyQuestLang['description']) ? self.state.systemLanguages[index].dailyQuestLang['description'] : ""} onChange={(event) => {self.setTitle(event, index, obj.slug)}}  />


                  <div className="validation-error">{ self.validator.message(self.state.systemLanguages[index].title+ ' tagline', (self.state.systemLanguages[index]['dailyQuestLang'] && self.state.systemLanguages[index]['dailyQuestLang']['description']) ? self.state.systemLanguages[index]['dailyQuestLang']['description'] : "", 'required') }</div>


                </FormGroup>
            </Col>
          </Row>
        </div>
      );
    })
  }


  setTitle(event, index, languageSlug) {
    this.handleChange(event);
    if (this.state.systemLanguages[index] && this.state.systemLanguages[index]['dailyQuestLang'] && this.state.systemLanguages[index]['dailyQuestLang'][event.target.name]) {
      this.state.systemLanguages[index]['dailyQuestLang'][event.target.name] = event.target.value;
      this.state.systemLanguages[index]['dailyQuestLang']['languageSlug'] = languageSlug;
      this.state.systemLanguages[index]['dailyQuestLang']['languageSlug'] = languageSlug;
    }else{
      this.state.systemLanguages[index]['dailyQuestLang'] = {};
      this.state.systemLanguages[index]['dailyQuestLang']= {
        [event.target.name] : event.target.value,
        languageSlug : languageSlug
      };
    }
    this.setState({systemLanguages : this.state.systemLanguages})

  }





  render() {
    let self = this;
    let { openAddAppQuestModal, closeModal, addQuestPopupError, contentData } = this.props;
    let { typedContent, requestProcess } = this.state;

    return (
      <Modal isOpen={openAddAppQuestModal}>
          <ModalHeader toggle={()=>{closeModal(false); this.clearStateData()}}>Add Quest</ModalHeader>
          <Form onSubmit={(event) => {this.handleSubmit(event)}}>
            <ModalBody>


              {this.LanguagesToRender()}

              <Row>
                <Col xs="12">
                  <FormGroup>
                      <Label htmlFor="content">Content</Label>
                      <div>
                      <Autocomplete
                          getItemValue={(item) => item.title}
                          items={contentData}
                          inputProps={{ id: 'autocomplete-input' , className: "form-control", placeholder:"Content search by title"}}
                          wrapperStyle={{  }}
                          renderItem={(item, isHighlighted) =>
                            <div key={item._id} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                              {item.title}
                            </div>
                          }
                          value={typedContent ? typedContent : ''}
                          onChange={(event, value)=>{
                            this.setState({typedContent: value, contentId: "", contentTitle: ''}, ()=>{
                              clearTimeout(self.requestTimer)
                              self.requestTimer = setTimeout(()=>{
                                self.props.getContent(value)
                              }, 1000)
                            });
                          }}
                          onSelect={(value, item)=>{this.onSelect(item)}}
                          selectOnBlur={true}
                        />
                        </div>
                        <div className="validation-error">{ this.validator.message('Content', this.state.contentId, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>


              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="tagline">Additional Points</Label>
                      <Input type="number" id="additionalPoints" placeholder="Additional Points" name="additionalPoints" value={this.state.additionalPoints} onChange={(event)=>{this.handleChange(event)}} min="1" max="1000"/>
                      <div className="validation-error">{ this.validator.message('Additional Points', this.state.additionalPoints, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>



              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="occurrence">Occurrence</Label>
                      <Input type="number" id="occurrence" placeholder="Occurrence" name="occurrence" value={this.state.occurrence} onChange={(event)=>{this.handleChange(event)}} min="1" max="100"  />
                      <div className="validation-error">{ this.validator.message('Occurrence', this.state.occurrence, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>


              <Row>
                <Col xs="12">
                    <FormGroup>
                        <Label htmlFor="status">Status</Label>
                        <div>
                          <AppSwitch className={ 'mx-1'} variant={ 'pill'} color={ 'primary'}  id="status"  name="status"
                            onChange={($event)=>{self.handleChange($event)}}
                            checked={(self.state.status)} />
                        </div>
                    </FormGroup>

                </Col>
              </Row>

              {(addQuestPopupError) ? <Alert color="danger">{addQuestPopupError}</Alert> : null}
            </ModalBody>
            <ModalFooter className="justify-content-left">
              <Button type="submit" size="sm" color="primary" disabled={requestProcess}>Add</Button>{' '}
              <Button type="reset" size="sm" color="danger"  onClick={() => { closeModal(); this.clearStateData() }}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>

    );
  }
}

export default AddQuest;
